import React, { useEffect } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from "../../config/authConfig";
import PropTypes from "prop-types";
import { Button, Link } from "@material-ui/core";

const SignInButton = (props) => {
  const handleLogin = async (instance) => {
    await instance.loginRedirect(loginRequest).catch((e) => {
      console.error(e);
    });
  };

  const handleLogout = (instance) => {
    instance.logoutRedirect().catch((e) => {
      console.error(e);
    });
  };
  const style = {
    marginRight: 10,
    color: "#fff",
    cursor: "pointer",
  };
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  useEffect(() => {}, [isAuthenticated]);

  if (!isAuthenticated) {
    console.log(isAuthenticated);
    switch (props.RenderAs) {
      case "Button":
        return (
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleLogin(instance)}
            style={style}
          >
            Sign-In
          </Button>
        );
      case "Link":
        return (
          <Link style={style} onClick={() => handleLogin(instance)}>
            Sign-In
          </Link>
        );
      case "NavLink":
        return (
          <Link style={style} onClick={() => handleLogin(instance)}>
            Sign-In
          </Link>
        );
      default:
        return (
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleLogin(instance)}
            style={style}
          >
            Sign-in
          </Button>
        );
    }
  } else if (isAuthenticated) {
    switch (props.RenderAs) {
      case "Button":
        return (
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleLogout(instance)}
            style={style}
          >
            Sign-Out
          </Button>
        );
      case "Link":
        return (
          <Link style={style} onClick={() => handleLogout(instance)}>
            Sign-Out
          </Link>
        );
      case "NavLink":
        return (
          <Link style={style} onClick={() => handleLogout(instance)}>
            Sign-Out
          </Link>
        );
      default:
        return (
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleLogout(instance)}
            style={style}
          >
            Sign-Out
          </Button>
        );
    }
  }
};

SignInButton.propTypes = {
  RenderAs: PropTypes.oneOf(["Button", "Link", "NavLink"]),
};

export default SignInButton;
